import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';

export class ProductSupplierForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'trykkerier', dataApiName: 'ProductSupplier', text: "Trykkerier", textSingular: "Trykkeri",
        primaryKey: 'num', baseFields: ['id', 'num', 'name', 'sorting', 'history']
      }, 
      fieldMetadata: [
        { name: 'onix', text: 'ONIX' }
      ]
    });
  }
}
